import { css } from 'lit';

export const guildJoinViewStyles = css`

  :host {
    background: linear-gradient(
      180deg,
      var(--theme-color-primary-4) 0,
      var(--view-gradient-end-color) 100vh
    );
  }

  view-content {
    margin: 0 auto;
    padding: 8rem 2rem 4rem 2rem;
    
    max-width: var(--q1-view-width);
    --q1-view-width: var(--q1-content-width-narrow);
  }

  /*=== SHARED STYLES & OVERRIDES ===*/

  sl-divider.full-width {
    width: calc(100% + (2 * var(--view-item-spacing)));
    margin: 0.5rem 0 0.5rem calc(-1 * var(--view-item-spacing)) !important;
    box-sizing: border-box;
  }

  /*=== GUILD HEADER ===*/

  q1-guild-card {
    margin-bottom: var(--view-item-spacing);
  }

  q1-guild-card::part(base) {
    padding: 0;
    overflow: visible;
  }
  q1-guild-card::part(card) {
    scale: 1;
  }

  guild-join-subheader {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: var(--view-item-spacing) 0;
  }
  
  #guild-headline {
    font-size: 1.2rem;
    line-height: 1.3em;
    font-weight: 200;
    color: var(--theme-text-color-primary);
    margin: var(--view-item-spacing) 0;
    text-align: center;
    padding: 0 1.5rem;
  }

  activation-status-panel {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    background: white;
    padding: 1.5rem;
    margin: var(--view-item-spacing) 0;
    border-radius: 12px;
    box-shadow: var(--sl-shadow-medium);
    margin-top: var(--view-item-spacing);
  }

  activation-status-panel h2 {
    margin: 0;
  }

  /*=== JOIN CARD ===*/

  #join-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;

    position: relative;
    overflow: hidden;

    background: white;
    border-radius: 12px;
    box-shadow: var(--sl-shadow-medium);
    margin-top: var(--view-item-spacing);

    padding: var(--view-item-spacing);

    margin-left: -1rem;
    margin-right: -1rem;
  }
  @media (min-width: 650px) {
    #join-card {
      margin-left: 0;
      margin-right: 0;
    }
  }

  #join-card h2 {
    margin: 0.5rem 0;
  }
  #join-card h3 {
    font-size: 1.3rem;
    line-height: 1.5em;
    margin: 0;
  }
  #join-card h4 {
    font-size: 1.2rem;
    line-height: 1.5em;
    margin: 0;
  }

  #join-card p {
    margin: 0;
  }

  /*=== FORMS ===*/

  form.q1 {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  form.q1 p.hero {
    margin: 0;
  }
  
  form.q1 sl-radio-group {
    margin: 0 !important;
  }

  form.q1 sl-input {
    margin: 0;
  }

  form.q1 q1-md-textarea {
    margin: 0;
    --label-width: 9rem;
  }

  form.q1 button-bar {
    align-items: center;
  }

  .disabled-help-text {
    font-style: italic;
    font-size: 0.9rem;
    color: var(--gray-6);
    font-weight: 200;
  }

  /*=== EXPLAINER PANEL ===*/

  p.explainer {
    line-height: 1.75em;
  }
  p.explainer strong {
    display: block;
    margin-bottom: -1rem;
  }

  /*=== ACTION PANEL ===*/

  action-panel {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1.6rem;
    border: 3px dashed var(--gray-3);
    border-radius: 12px;
    background: var(--gray-0);
    
    width: 100%;
    box-sizing: border-box;
  }

  action-panel h3, action-panel p, action-panel p.subtitle {
    margin: 0;
  }

  action-panel p.footer {
    color: var(--gray-6);
    --link-color-default: var(--gray-6);
    --link-color-visited: var(--gray-6);
    --link-color-focus: var(--gray-8);
  }

  /*=== ORGANIZERS LIST ===*/

  organizers-list {
    display: block;
    width: 100%;
    margin: 0;

    border: solid 1px var(--gray-2);
    border-radius: 12px;
    overflow: hidden;
  }

  organizers-list q1-member-chip {
    padding: 0.75rem 1rem;
    background: white;
    border: 1px solid var(--gray-1);
    margin: -1px; /* to prevent double borders */

    transition: all 0.2s ease-in-out;
  }
  organizers-list q1-member-chip:hover,
  organizers-list q1-member-chip:focus {
    background: var(--gray-1);
  }

  
`;